<template>
    <CRow>
        <CDataTable
            class="col-12 px-0"
            :items="Object.values(users)"
            :fields="$dataTableFieldsMaker(fields)"
            hover
            :loading="fetchStatus == 'LOADING'"
            :pagination="{ ...pagination, change: fetchUsers, limit: 10 }"
            addTableClasses="bg-white"
            :key="keyOfTable"
        >
            <template #id="{ item }">
                <td class="font-xs text-center">
                    {{ item.non_hash_id }}
                </td>
            </template>

            <template #phone="{ item }">
                <td class="text-center">
                    {{ item.phone }}
                </td>
            </template>

            <template #fullName="{ item }">
                <td class="text-center">
                    <span class="d-block text-affili-indigo font-weight-bold" style="font-size: smaller;">{{ item.role ? item.role.name : '-' }}</span>
                    <img v-if="item.avatar" :src="item.avatar" :alt="item.full_name" width="25px" />
                    <span class="d-block" style="white-space:break-spaces;">{{ item.full_name }}</span>
                </td>
            </template>

            <template #createdAt="{ item }">
                <td class="text-center">{{ $moment(item.created_at).format('LL') }}</td>
            </template>

            <template #lastActivity="{ item }">
                <td class="text-center">{{ item.last_activity || '-' }}</td>
            </template>

            <template #responsible="{item}">
                <td class="text-center" style="width: 140px">
                    <CSelect
                        class="mb-0"
                        addInputClasses="small"
                        :options="responsibles"
                        @update:value="value => selectResponsible(item.id, value)"
                        :value="item.responsible"
                    />
                </td>
            </template>

            <template #status="{item}">
                <td style="width:130px;">
                    <CSelect
                        class="mb-0"
                        addInputClasses="small"
                        :options="statuses"
                        @update:value="value => selectStatus(item.id, value)"
                        :value="item.activity_status"
                    />
                </td>
            </template>

            <template #setupStatus="{item}">
                <td class="text-center" style="width: 160px" :key="item.id + '-status-' + (item.skey ? item.skey : 0)">
                    <CSelect2
                        class="mb-0"
                        addInputClasses="small"
                        :options="UserSetupStatusOption"
                        @update="(newVal, oldVal) => selectSetupStatus(item, newVal, oldVal)"
                        :value="item.setup_status"
                    />
                </td>
            </template>

            <template #actions="{ item }">
                <td class="text-center">
                    <CLink
                        class="px-1"
                        v-if="$policy('user', item).edit"
                        :to="{ name: 'users.edit', params: { id: item.id } }"
                    >
                        <FaIcon icon="edit" />
                    </CLink>
                    <CLink
                        class="px-1"
                        v-else-if="$policy('user', item).soft_delete"
                        @click="openModal(item)"
                    >
                        <FaIcon icon="trash-restore" class="text-warning" />
                    </CLink>
                    <CLink
                        class="px-1"
                        v-if="$policy('user', item).details"
                        @click="openDetailsModal(item)"
                    >
                        <FaIcon icon="eye" class="text-info" />
                    </CLink>
                    <CLink
                        class="px-1"
                        v-if="$policy('user', item).edit"
                        @click="openTagsModal(item)"
                    >
                        <FaIcon icon="tag" class="text-info" />
                    </CLink>
                </td>
            </template>
        </CDataTable>
        <CModal
            v-if="modalItem"
            :title="$t('user.data')"
            color="dark"
            :size="modalItem.store_users.length > 0 || modalItem.medias.length > 0 || modalItem.stores.length > 0 ? 'xl' : ''"
            :show.sync="showDetailsModal"
        >
            <CRow>
                <CCol
                    :lg="modalItem.store_users.length > 0 || modalItem.medias.length > 0 || modalItem.stores.length > 0 ? 5 : 12"
                    sm="12"
                >
                    <DetailsTable class="w-100" :item="modalItem" :keywords="keywords" />
                </CCol>
                <CCol
                    lg="7"
                    sm="12"
                    v-if="modalItem.store_users.length > 0 || modalItem.medias.length > 0 || modalItem.stores.length > 0"
                >
                    <CDataTable
                        v-if="modalItem.store_users.length > 0"
                        :items="store_users.items"
                        :fields="store_users.fields"
                        hover
                        addTableClasses="bg-white"
                    >
                        <template #logo="{ item }">
                            <td>
                                <img :src="item.logo" class="w-25 h-auto" />
                            </td>
                        </template>
                    </CDataTable>
                    <CDataTable
                        v-if="modalItem.medias.length > 0"
                        :items="medias.items"
                        :fields="medias.fields"
                        hover
                        addTableClasses="bg-white"
                    >
                        <template #created_at="{ item }">
                            <td>{{ $moment(item.created_at).format('LL') }}</td>
                        </template>

                        <template #type="{ item }">
                            <td class="text-center">{{ typeStr(item.type) }}</td>
                        </template>

                        <template #status="{ item }">
                            <td class="text-center large">
                                <span
                                    :class="'badge badge-' + mediaStatusColor(item.status)"
                                >{{ mediaStatusStr(item.status) }}</span>
                            </td>
                        </template>

                        <template #url="{ item }">
                            <td class="text-center large">
                                <a :href="item.url" target="_blank"><FaIcon icon="link" /></a>
                            </td>
                        </template>
                    </CDataTable>
                    <CDataTable
                        v-if="Object.keys(modalItem.stores).length > 0"
                        :items="stores.items"
                        :fields="stores.fields"
                        hover
                        addTableClasses="bg-white"
                    >
                        <template #logo="{ item }">
                            <td>
                                <img :src="item.logo" class="w-25 h-auto" />
                            </td>
                        </template>

                        <template #status="{ item }">
                            <td class="text-center large">
                                <span
                                    :class="'badge badge-' + storeStatusColor(item.status)"
                                >{{ storeStatusStr(item.status) }}</span>
                            </td>
                        </template>
                    </CDataTable>
                </CCol>
            </CRow>

            <template #footer-wrapper>
                <div></div>
            </template>
        </CModal>
        <CModal
            v-if="modalItem"
            :title="$t('user.delete')"
            :color="UserStatusConst.isRemoved(modalItem.status) ? 'warning' : 'danger'"
            :show.sync="showModal"
        >
            <span
                v-if="UserStatusConst.isRemoved(modalItem.status)"
            >{{ $t('user.are_you_sure_to_restore', { attribute: modalItem.full_name }) }}</span>
            <span v-else>
                {{ $t('user.are_you_sure_to_remove', { attribute: modalItem.full_name }) }}
                <CSelect2
                    v-model="deleteReason"
                    class="mt-4"
                    :label="$t('user.delete_reason._')"
                    :options="userDeleteReasonOption"
                />
            </span>
            <template #footer>
                <CButton @click="showModal = false" color="secondary">{{ $t('cancel') }}</CButton>
                <CButton
                    v-if="UserStatusConst.isRemoved(modalItem.status)"
                    @click="showModal = false, restoreUser(modalItem.id)"
                    color="warning"
                >{{ $t('restore') }}</CButton>
                <CButton
                    v-else
                    @click="showModal = false, deleteUser({ id: modalItem.id, delete_reason: deleteReason }), deleteReason = null"
                    color="danger"
                >{{ $t('delete') }}</CButton>
            </template>
        </CModal>

        <CModal
            :show.sync="tagModal.show"
        >
            <CCol sm="12">
                <Message />
                <VueTagsInput
                    add-only-from-autocomplete
                    :autocomplete-items="filteredStoreTags"
                    placeholder="افزودن علاقه‌مندی"
                    v-model="tag"
                    :tags="tagModal.item.tags"
                    @tags-changed="newTags => tagModal.item.tags = newTags"
                />
            </CCol>

            <template #footer>
                <CButton @click="tagModal.show = false" color="secondary">{{ $t('cancel') }}</CButton>
                <CButton
                    @click="saveTags(tagModal.item)"
                    color="primary"
                >{{ $t('submit') }}</CButton>
            </template>
        </CModal>

        <CModal
            :v-if="changeSetupStatusModal.show"
            :show.sync="changeSetupStatusModal.show"
        >
            <template #header-wrapper>
                <span></span>
            </template>
            {{ $t('user.specify_change_setup_status_reason') }}

            <CSelect2
                class="mb-0"
                addInputClasses="small"
                :options="UserChangeSetupStatusReasonOption"
                v-model="changeSetupStatusReason"
            />

            <template #footer>
                <CButton
                    @click="changeSetupStatusModal.show = false"
                    color="secondary"
                >{{ $t('cancel') }}</CButton>
                <CButton
                    :disabled="changeSetupStatusReason === null"
                    @click="selectSetupStatus(changeSetupStatusModal.item, changeSetupStatusModal.newVal, changeSetupStatusModal.item.status, true)"
                    color="danger"
                >{{ $t('reject') }}</CButton>
            </template>
        </CModal>
    </CRow>
</template>

<script>
import fields, { keywords, store_users, medias, stores} from './fields'
import { mapActions, mapGetters } from 'vuex'
import {
    userStatusStr,
    userStatusColor,
    UserStatusConst,
    userInputClass,
} from './methods'
import { userStatusOption, userDeleteReasonOption, UserSetupStatusOption, UserChangeSetupStatusReasonOption } from '@/common/data'
import { typeStr, mediaStatusStr, mediaStatusColor, storeStatusStr, storeStatusColor } from './methods'
import { userService } from '@/services/api'
import VueTagsInput from '@johmun/vue-tags-input'
import { UserSetupStatus } from '@/constants'

export default {
    name: 'Table',

    components: {
        VueTagsInput,
    },


    data() {
        return {
            keywords,
            UserSetupStatus,
            userStatusOption,
            userDeleteReasonOption,
            UserSetupStatusOption,
            fields,
            UserStatusConst,
            showDetailsModal: false,
            showModal: false,
            modalItem: false,
            deleteReason: null,
            id: this.$route.params.id,
            store_users,
            medias,
            stores,
            tagModal: {
                item: false,
                show: false,
            },
            changeSetupStatusModal: {
                item: {},
                show: false,
                newVal: ''
            },
            changeSetupStatusReason: null,
            tag: '',
            keyOfTable: 0,
            UserChangeSetupStatusReasonOption,
        }
    },

    computed: {
        ...mapGetters({
            pagination: 'user/pagination',
            users: 'user/users',
            current: 'user/current',
            login_as_token: 'user/login_as_token',
            filterMeFields: 'filterMeComponent/filterMeFields',
            storeTags: 'store/tagsInput',
            fetchStatus: 'user/status',
        }),
        responsibles() {
            return [
                '',
                'داود سرائی',
                'سینا عبداللهی',
                'فاطمه خانجانی',
            ]
        },
        statuses() {
            return [
                '',
                'فعال',
                'غیرفعال',
                'معلق',
                'ثبت‌نام اشتباه',
                'منصرف شده',
            ]
        },

        filteredStoreTags() {
            return this.storeTags.filter(i => {
                return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
            })
        }
    },

    watch: {
        fetchStatus() {
            this.keyOfTable = this.keyOfTable + 1
        }
    },

    methods: {
        ...mapActions({
            findUser: 'user/find',
            deleteUser: 'user/delete',
            restoreUser: 'user/restore',
            changeStatus: 'user/changeStatus',
            changeResponsible: 'user/changeResponsible',
            loginAsById: 'user/loginAs',
            fetch: 'user/fetch',
            changeSetupStatus: 'user/changeSetupStatus',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
        }),
        storeStatusStr,
        storeStatusColor,
        typeStr,
        mediaStatusStr,
        mediaStatusColor,
        fetchUsers(activePage = 1) {
            this.fetch({
                page: activePage,
                ...this.filterMeFields
            })
        },
        userStatusStr,
        userStatusColor,
        userInputClass,
        openDetailsModal(userI) {
            if (userI.fetch_find) {
                this.modalItem = userI
                if (userI.store_users.length > 0) {
                    this.store_users.items = userI.store_users
                }
                if (userI.medias.length > 0) {
                    this.medias.items = userI.medias
                }
                if (userI.stores.length > 0) {
                    this.stores.items = userI.stores
                }
                this.showDetailsModal = true
                return
            }

            this.findUser(userI.id).then((res) => {
                const user = res.data
                this.modalItem = user
                if (user.store_users.length > 0) {
                    this.store_users.items = user.store_users
                }
                if (user.medias.length > 0) {
                    this.medias.items = user.medias
                }
                if (user.stores.length > 0) {
                    this.stores.items = user.stores
                }
                this.showDetailsModal = true
            })
        },
        openModal(user) {
            this.modalItem = user
            this.showModal = true
        },
        selectResponsible(userId, val) {
            this.changeResponsible({id: userId, responsible: val})
        },
        selectStatus(userId, val) {
            this.changeStatus({id: userId, activity_status: val})
        },
        selectSetupStatus(user, newVal, oldVal, confirmed = false) {
            if (newVal !== UserSetupStatus.COMPLETE && newVal !== UserSetupStatus.PENDING_TO_ACTIVE && !confirmed) {
                user.skey = (user.skey ? user.skey : 0) + 1
                user.setup_status = oldVal
                this.changeSetupStatusModal = { item: user, show: true, newVal: newVal }

                return false
            }

            this.changeSetupStatus({
                id: user.id,
                setup_status: newVal,
                change_setup_status_reason: newVal === UserSetupStatus.COMPLETE ? null : this.changeSetupStatusReason
            }).then(() => {
                this.changeSetupStatusReason = null
                this.changeSetupStatusModal = { item: {}, show: false, newVal: '' }
            })
        },
        openTagsModal(user) {
            this.resetMsg()
            userService.getTags(user.id, {}).then(resp => {
                this.tagModal = {
                    item: {
                        user: user,
                        tags: resp.data.data.map(tag => {
                            return {text: tag.name}
                        })
                    },
                    show: true
                }
            })
        },
        saveTags(item) {
            this.resetMsg()
            const tags = item.tags.map(tag => tag.text)

            userService.syncTags(item.user.id, {
                tags: tags
            }).then(resp => {
                this.setMsg({
                    content: 'علاقه‌مندی‌ها بروزرسانی شد.',
                    type: 'success'
                })
            })
        },
        getDropdownValues() {
            return []
        }
    }
}
</script>

<style scoped>
.table td {
    vertical-align: middle !important;
}
</style>